import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, tap } from 'rxjs';

import { BetslipTeaserActions } from '../actions';
import { TeaserBetPickSubscriptionService } from '../services/teaser-bet-pick-subscription.service';
import { BetslipTeaserCdsActions } from '../teaser-bet-cds.actions';

@Injectable()
export class TeaserBetCdsEffects {
    constructor(
        private actions$: Actions,
        private subscriptionService: TeaserBetPickSubscriptionService,
    ) {}

    /**
     * Handle subscribe to pick action
     */
    handleSubscribeToPickActionEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(BetslipTeaserCdsActions.subscribeToPick),
                tap((action) => {
                    this.subscriptionService.subscribeToPicks([action.payload]);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    /**
     * Handle unsubscribe from pick action
     */
    handleUnsubscribeFromPickActionEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(BetslipTeaserCdsActions.unsubscribeFromPick),
                tap((action) => {
                    this.subscriptionService.unsubscribeFromPicks([action.pickId]);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    /**
     * Handle unsubscribe from all picks action
     */
    handleUnsubscribeAllActionEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(BetslipTeaserCdsActions.unsubscribeAll),
                tap((_) => {
                    this.subscriptionService.unsubscribeFromAll();
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    /**
     * When alternate pick is changed subscribe for pick changes.
     */
    handleTeasePickActionEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipTeaserActions.teasedPickChanged),
            map((action) => {
                if (action.oldPick) {
                    BetslipTeaserCdsActions.unsubscribeFromPick({ pickId: action.oldPick.id });
                }

                return BetslipTeaserCdsActions.subscribeToPick({
                    payload: {
                        pickId: action.newPick.id,
                        context: action.newPick.subscriptionContext,
                        fromHybridFixture: action.newPick.fromHybridFixture,
                    },
                });
            }),
        );
    });

    /**
     * When picks are removed remove picks subscription.
     */
    handleRemovePicksActionEffect$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipTeaserActions.removePicksFinished),
            concatMap((action) => action.pickIds.map((pickId) => BetslipTeaserCdsActions.unsubscribeFromPick({ pickId }))),
        );
    });
}
